<template>
  <div class="editable-container">
    <h3 v-if="!isEditing">{{ value }}</h3>
    <b-button
      variant="outline-dark ml-2"
      size="sm"
      v-if="!isEditing && editable"
      @click="isEditing = true"
      data-cy="editable-title-rename"
      >rename</b-button
    >
    <div style="margin-bottom: 10px; display: flex; align-items: baseline">
      <b-input
        type="text"
        v-model="localValue"
        v-if="isEditing"
        style="width: 350px"
        data-cy="editable-title-input"
      />
      <b-button
        variant="outline-danger ml-2"
        size="sm"
        v-if="isEditing"
        @click="cancel"
        style="margin-bottom: 1rem"
        >cancel</b-button
      >
      <b-button
        variant="success ml-1"
        size="sm"
        v-if="isEditing"
        @click="save"
        style="margin-bottom: 1rem"
        data-cy="editable-title-save"
        >save</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "EditableTitle",
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isEditing: false,
      localValue: this.value
    };
  },
  methods: {
    cancel() {
      this.localValue = this.value;
      this.isEditing = false;
    },
    save() {
      this.$emit("valueChanged", this.localValue);
      this.isEditing = false;
    }
  }
};
</script>

<style scoped>
.editable-container {
  display: flex;
  align-items: center;
}
</style>